interface IConfigurationValues {
    apiUrl: string;
    coreApiUrl: string;
    wspApiUrl: string;
    publicUrl: string;
    mainUrl: string;
    reactPublicUrl: string;
    appInsightsConnectionString: string;
    environment: string;
    functionAppUrl: string;
    populateFunctionAppUrl: string;
    enable_notification_settings: string;
    enable_react_migration: string;
    cookieTimeoutInMinutes: string;
    enable_income_differentials_graphs: string;
    enable_certificate_registry: string;
    enable_central_management: string;
    enable_employment_equity_salary: string;
    enable_VAIntegrationSubmissionProcess: string;
    enable_CDMExportFunctionality: string;
    enable_WSPATR: string;
    enable_VA_client_excel_import: string;
    enable_VAScorecardSubmissionProccess: string;
    enable_VA_client_contacts_import: string;
    advisory_registration_id: string;
    enable_new_EE_workforce_tables: string;
    keycloakUrl: string;
    enable_new_EE_Reporting_Dashboards: string;
    enable_new_EEA_Reports: string;
    enable_va_excel_exports: string;
    enable_iframe_pages: string;
    enable_enhanced_deviations: string;
    posthogKey: string;
}

declare global {
    interface Window { MyConfig: IConfigurationValues; }
}

const config = window.MyConfig;

export default config;